<template>
    <div>
        <h4>
            <slot name="title">
                {{ title }}
            </slot>
        </h4>
        <p>
            <slot name="sort-description">
                {{ sortDescription }}
            </slot>
        </p>
        <hr />
    </div>
</template>

<script>
export default {
    name: "FormSectionDescription",
    data() {
        return {};
    },
    props: {
        title: {
            require:true
        },
        sortDescription: {
            require:true
        },
    },
};
</script>

<style lang="scss" scoped>
</style>